import { Box, Grid, Popover, Typography, useMediaQuery } from '@mui/material'
import { FileList } from 'components'
import { theme } from 'config'
import { observer } from 'mobx-react'
import { Course, Step, Task } from 'models'
import React, { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading } from 'views'
import { TaskType } from 'types'
import { QuizResult } from './quizResult'
import { QuizTask } from './quizTask'
import { InfoOutlined } from '@mui/icons-material'

export interface IQuizCourseProps {
  step: Step
  course: Course
  setRatingAdded: Dispatch<SetStateAction<boolean>>
  setAreColumnAnswersChecked: (checked: boolean) => void
}

export const QuizCourse = observer((props: IQuizCourseProps) => {
  const {
    step,
    course,
    setRatingAdded,
    setAreColumnAnswersChecked,
  } = props
  const { t } = useTranslation()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // Detect mobile devices

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const curTask: Task = step.quiz?.tasks.length
    ? step.quiz?.tasks[step.quiz.cur_task_idx]
    : null

  if (
    step?.quiz?.alreadyPassed ||
    (step?.quiz?.isCompleted && step.quiz.correct_answers > -1)
  ){
    // if(curTask.type === TaskType.Column){
    //   return (
    //     <QuizResult
    //       step={step}
    //       course={course}
    //       setRatingAdded={setRatingAdded}
    //       isColumn={true}
    //     />
    //   )
    // }
    return (
      <QuizResult step={step} course={course} setRatingAdded={setRatingAdded} />
    )
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'popover' : undefined

  return !step?.quiz ? (
    <Loading />
  ) : (
    <>
      <Box
        className='quizCourse'
        display='grid'
        gridTemplateColumns='1fr repeat(2, auto) 1fr'
        alignItems={'center'}
        position='relative'
        width='100%'
      >
        <Typography
          textAlign='center'
          sx={{ gridColumn: '2', maxWidth: isMobile ? '14ch' : 'none' }}
          variant={isMobile ? 'h5' : 'h4'}
        >
          {step.title}
        </Typography>
        {step.quiz &&
          step.quiz.tasks.length > 0 &&
          curTask?.type !== TaskType.Column && (
            <Typography
              textAlign='center'
              sx={{
                gridColumn: '2',
                maxWidth: isMobile ? '14ch' : 'none',
                margin: '2rem',
              }}
              variant={isMobile ? 'h6' : 'h5'}
            >
              {t('question_x_of_y', {
                questionNo:
                  step.quiz.cur_task_idx != null
                    ? step.quiz.cur_task_idx + 1
                    : 1, // Default to 1 if `cur_task_idx` is undefined
                totalQuestions: step.quiz.tasks.length,
              })}
            </Typography>
          )}
        {curTask?.type === TaskType.Column && (
          <>
            <div
              style={{
                gridColumn: '4',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
              }}
            >
              <Typography sx={{ fontSize: 14, lineHeight: 1 }}>
                {t('guide')}
              </Typography>
              <button
                aria-describedby={id}
                onClick={handleClick}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '4px',
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  opacity: 0.8,
                  width: '24px',
                  height: '24px',
                  borderRadius: '50%',
                  transition: 'background-color 0.2s',
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.1)')
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = 'transparent')
                }
              >
                <InfoOutlined
                  fontSize='small'
                  style={{
                    fontSize: '20px',
                    pointerEvents: 'none',
                  }}
                />
              </button>
            </div>
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
            >
              <div style={{ padding: '4px', border: '1px solid' }}>
                <p style={{ fontSize: '16px', margin: '0', lineHeight: '1.1' }}>
                  {t('guide_desktop')}
                </p>
                <p style={{ fontSize: '16px', margin: '0', lineHeight: '1.1' }}>
                  {t('guide_mobile')}
                </p>
              </div>
            </Popover>
          </>
        )}
      </Box>
      <QuizTask
        task={curTask}
        setAreColumnAnswersChecked={setAreColumnAnswersChecked}
      />
      {step.getDocuments.length > 0 && (
        <Grid mt={theme.spacing(4)} item width='100%' xs={12} margin='auto'>
          <FileList files={step.getDocuments} />
        </Grid>
      )}
    </>
  )

  
})
